import {PH_BACKGROUND} from "./placeHolders";

export const ACTIVITY = "Actividades x Entrada";
export const NEW = "Nuevo";
export const EDIT = "Editar";
export const DELETE = "Eliminar";
export const SAVE = "Guardar";
export const CLOSE = "Cerrar";
export const RETURN = "Ir al inicio";
export const CANCEL = "Cancelar";
export const ACCEPT = "Aprobar";
export const REJECT = "Rechazar";
export const SYNC = "Sincronizar";
export const UPD_PRICES = "Actualizar precios";
export const LIST = "Lista";
export const MAP = "Mapa";
export const CALENDAR = "Calendario";
export const BENEFIT = "Beneficios";
export const TABOPTION = "Tabs";
export const PRODUCTS = "Productos";
export const PRICES = "Precios";
export const ACTIVITIES = "Actividades";
export const FORM = "Datos generales";
export const INTERNATIONAL = "Información internacional";
export const ADD = "Agregar";
export const SEARCH = "Buscar";
export const CLEAN = "Limpiar";
export const FILTERS = "Filtrar";
export const SHOW = "Mostrar";
export const HIDE = "Ocultar";
export const VIEW_DETAIL = "Ver detalle";
export const REFRESH = "Refrescar";
export const LIST_VIEW = "Mostrar lista";
export const MAP_VIEW = "Mostrar mapa";
export const CALENDAR_VIEW = "Mostrar calendario";
export const CANVAS_VIEW = "Miniaturas";
export const TARGET_FIREBASE = "Base de datos en Firebase";
export const CHANGE = "Cambiar";
export const SCHEDULE = "Horarios";
export const AWARDS = "Premios";
export const GALLERY = "Galeria";
export const GALLERY_HEADER = "Galeria";
export const PROGRAM = "Programa de manos";
export const UDN = "Unidad de negocios";
export const MENUS = "Menus";
export const ASG_ROLE = "Asignar Roles";
export const ASG_PERM = "Asignar Permisos";
export const OK = "Aceptar";
export const PERM = "Permisos";
export const NOTHING_TO_SAVE = "No hay cambios que guardar";
export const ARE_YOU_SHURE_TITLE = "¿Estas Seguro?";
export const ARE_YOU_SHURE_MSG = "Quieres eliminar el siguiente registro";
export const ARE_YOU_SURE_CONFIRMATION_PROCESS = "¿Estas seguro de confirmar el siguiente proceso?";

export const ARE_YOU_SHURE_CONFIRM_MSG = "Desea confirmar al servicio";
export const ARE_YOU_SHURE_REJECT_MSG = "Desea rechazar al servicio";
export const ARE_YOU_SHURE_PROCESS_MSG = "Desea cambiar a en proceso al servicio";
export const ARE_YOU_SHURE_CANCEL_MSG = "Desea cancelar al servicio";
export const APPROVE_ON_MSG = "Quieres APROBAR este cambio para que se sincronice con Firebase y se vea reflejado en la app.";
export const APPROVE_MSG = "Quieres APROBAR estos cambios para todos los registros seleccionados que se sincronicen con Firebase y se vean reflejados en la app.";
export const REJECT_ONE_MSG = "Quieres RECHAZAR este cambio para que no se sincronice con Firebase y no se vea reflejado en la app.";
export const REJECT_MSG = "Quieres RECHAZAR estos cambios para todos los registros seleccionados que no se sincronicen con Firebase y no se vean reflejados en la app.";
export const NOT_FOUND_MSG = "No se ha encontrado el recurso solicitado, favor de intentar mas tarde.";
export const NO = "No";
export const YES = "Si, elimínalo"
export const YES_CONFIRM = "Si"
export const YES_CONTINUE = "Continuar"
export const CONTINUE = "Continuar"
export const title_release = "¡¡¡ ADVERTENCIA !!!"
export const title_body = "A continuación se muestran las ultimas versiones de la app para cada plataforma. Una valor menor conyeva a que se vizualice dentro de la app publicada en tiendas."
export const YES_ACCEPT = "Si, acepto"
export const REQUIRED = "Campo obligatorio"
export const MAX_NAME = "50 caracteres máximo"
export const MAX_DESCRIPTION = "255 caracteres máximo"
export const HISTORY = "Historial"

export const fileOption = "Seleccione un archivo"
export const updatePassword = "Contraseña actualizada exitosamente"
export const badPassword = "La contraseña actual es incorrecta"
export const loginErrorMsg = "Usuario o contraseña incorrecto, por favor contacte con el administrador."
export const NO_DATA_FOUND = "No se encontraron datos para el registro solicitado."
export const errorOnLoad = "Error al cargar opciones."

export const IMAGE_FORMATS = "image/png, image/jpeg"
export const VIDEO_FORMATS = "video/mp4"
export const NOT_MARKERS = "No existen datos para los siguientes parámetros de búsqueda"

export const TOOLTIP_EDIT_AMENITIES = "Editar amenidades";
export const TOOLTIP_EDIT_ROOM_PLACE = "Editar lugares";
export const TOOLTIP_EDIT_PLACE_ROOM = "Editar cuartos";

// CONFIRM
export const CONFIRM_SYNC = "Debe confirmar la accion, el proceso puede demorar";
export const CONFIRM_YES = "Si, continuar"
// TOAST
export const TOAST_SYNC_NO_PROMO_PRICES = "Actualiza los precios de todos los productos sin promoción y sincroniza a firebase";
export const TOAST_SYNC_ALL_PROMOTIONS_PRICES = "Actualiza los precios de todos los productos en todas las promociones y sincroniza a firebase";
export const TOAST_SYNC_SINGLE_PRODUCT_NO_PROMO_PRICES = "Actualiza los precios del producto seleccionado sin promoción y sincroniza a firebase";
export const TOAST_SYNC_PROD_LANG = "Sincroniza a firebase: Productos";

export const success = "success"
export const info = "info"
export const error = "error"
export const warning = "warning"
export const saveMsg = "Guardado Existosamente"
export const saveErrorMsg = "No fue posible guardar los datos"
export const updateMsg = "Actualizado exitosamente"
export const deleteMsg = "Se ha eliminado un registro"
export const deleteErrorMsg = "No se puede eliminar, existen registros asociados"
export const infoMsg = "No se a cambiado ningún valor"
export const fbPathNotFound = 'No se encontro path de firebase'
export const selectOption = "Seleccione al menos una opción"
export const selectUdn = "Debe seleccionar una unidad de negocio, si intenta dar de alta un nuevo registro, ingrese la informaciòn manualmente."
export const selectMarker = "Seleccione un marcador del mapa"
export const priceValidationError = "El valor para presentación por botella debe ser mayor a cero tanto para USD como MXN."

// ENCABEZADOS DE TABLA
export const CURRENCY_HEADER = "Moneda"
export const CURRENCY_USD_HEADER = "Moneda USD"
export const CURRENCY_MXN_HEADER = "Moneda MXN"
export const LAST_UPDATE_HEADER = "Ultima actualización"
export const PRICE_HEADER = "Precio"
export const PRICE_CUP_HEADER = "Precio por copa"
export const PRICE_BOTTLE_HEADER = "Precio por botella"
export const DISCOUNT_HEADER = "Descuento"
export const SAVINGS_HEADER = "Ahorro"
export const PREBUY_HEADER = "Pre-compra"

//LABELS
export const LB_EMPTY_TABLE = 'No se encontró información registrada'
export const LB_PRIORITY = 'Prioridad'
export const LB_HOME = 'Home'
export const LB_CODE = "Código"
export const LB_NAME = "Nombre"
export const LB_ACTIONS = "Acciones"
export const LB_LATITUD = "Latitud"
export const LB_LONGITUD = "Longitud"
export const LB_ADDRESS = "Dirección"
export const LB_ORDER = "Orden"
export const LB_ACTIVE = "Activo"
export const LB_CONTACT_TYPE = 'Tipo de Contacto'
export const LB_VALUE = 'Valor'
export const LB_MENU_PRODUCTS = 'Productos del Menú'
export const LB_PRODUCTS_LIST = 'Lista de productos'
export const LB_ASSIGNED = 'Asignado'
export const LB_TITLE = 'Título'
export const LB_VISITOR = 'Visitante'
export const LB_DATE = 'Fecha'
export const LB_SALES_CODE = 'Código de venta'
export const LB_APPLICATIVE = 'Aplicación'
export const LB_UDN = 'Unidad de negocio'
export const LB_STATUS = 'Status'
export const LB_CONFIRM = 'Confirmar'
export const LB_REMOVE = 'Remover'
export const LB_TYPE = 'Tipo'

//XAILING
export const XA_ORIGIN_PORT = 'Puerto de Origen'
export const XA_DESTINY_PORT = 'Puerto de Destino'
export const XA_ADMISSION = 'Entrada'

export const NEAR_PLACE = "Lugares cercanos";


//Amenity
export const AMENITY_LIST = "Lista de Amenidades"

//Translate
export const TRANSLATE_LABEL = "Traducir"
export const TRANSLATE_ITEM_CONFIRMATION = "¿Confirma la traducción?"
export const TRANSLATE_ITEM_MSG = "Esta acción traducirá en todos los idiomas registrados en la aplicación"
export const SUCCESSFUL_TRANSLATION_LABEL = "Tradución exitosa"
export const SELECT_LANGUAGE_LABEL = "Selecciona el idioma"
export const UPDATE_GLOSSARY_LABEL = "Acualizar el Glosario"

// apps
export const LOADING_APPLICATIONS = "Cargando aplicaciones"
export const APPLICATIONS = "Aplicaciones"

// AYB
export const SELECT_CHEFF = "Selecciona un Chef";

// prices manually assigned
export const EXCHANGE_PRICE = 'Actualizar precios'
export const ASSIGN_PRICES = 'Asignar Precios'
export const PAX_TYPE = 'Tipo de pax'
export const SUCCESSFUL_ASSIGNED_PRICE_LABEL = "Precio correctamente asignado"
export const SUCCESSFUL_REMOVE_ASSIGNED_PRICE_LABEL = "Asignación manual de precio removido"
export const REMOVE_PRICES_MANUAL_ASSIGNATION = 'Remover asignación manual'
export const MANUALLY_ASSIGNED = "Manual"

// json compare
export const JS_INCOMPLETE_DATA = 'Datos incompletos'
export const JS_ACTUAL_LB = 'Actual'
export const JS_CAMBIOS_LB = 'Cambios'
export const JS_CHANGE_REQUESTED_BY = 'Cambio Solicitado por'
export const JS_ACTION_TYPE = 'Tipo de Acción'
export const JS_APPLICATION_DATE = 'Fecha de Solicitud'
export const JS_REQUEST_STATUS = 'Status de la Solicitud'
export const JS_VIEW_TYPES = 'Tipos de Vista'

// wishlist
export const LB_SERVICE = 'Servicio'
export const LB_TRANSPORTATION = 'Transportación'
export const LB_PARK = 'Parque y Tours'
export const LB_AIRLINE = 'Aerolíena'
export const LB_AIRPORT = 'Aeropuerto'
export const LB_TERMINAL = 'Terminal'
export const LB_FLIGHT_NUMBER = 'No de vuelo'
export const LB_FLIGHT= ' vuelo'
export const LB_HOUR = 'Hora'
export const LB_NUMBER_PAX = 'Número de personas'
export const LB_PAX = '# Personas'
export const LB_PEOPLE = 'Personas'
export const LB_NATIONAL = 'Nacional'
export const LB_INTERNATIONAL = 'Internacional'
export const LB_COMMENTS = 'Comentarios'
export const LB_SPA = 'Spa'
export const LB_TREATMENT = 'Tratamiento'
export const LB_SHARE_CABINE = 'Cabina Separada'
export const LB_CONFIRMATION_CODE = 'Código de confirmación'
export const LB_ADD_SERVICE = 'Agregar Servicio'
export const LB_BIRTHDAY = 'Cumpleaños'
export const LB_ANIVERSARY = 'Aniversario'
export const LB_HONEYMOON = 'Luna de miel'
export const LB_HANDICAP = ' Habitación Handicap'
export const LB_PET = 'Mascota $150USD c/u'
export const LB_ALLERGIES = 'Alergias'
export const LB_CELEBRATIONS = 'Celebraciones'
export const LB_SPECIAL_CASES = 'Especiales'
export const LB_OTHERS = 'Otros'
export const LB_PICKUP = 'Pickup'
export const LB_PICKUP_HOUR = 'Hora de Pickup'
export const LB_FLIGHT_HOUR = 'Hora de vuelo'
export const LB_PICKUP_HOUR_REQUIRED = 'Es necesario indicar la hora de pickup'
export const LB_DELIVER = 'Deliver'
export const LB_CONFIRMATION = 'Confirmación'
export const LB_RESERVATION_NUMBER = 'Número de reservación'
export const LB_RESTAURANT = 'Restaurante'
export const LB_HOTEL = 'Hotel'
export const LB_PICKUP_INDICATOR = 'Aeropuerto–Hotel'
export const LB_DELIVER_INDICATOR = 'Hotel–Aeropuerto'
export const LB_WIXLIST = 'Wixlist'
export const LB_WL_RESERVA = 'No. reserva'
export const LB_WL_GUEST = 'Huesped'
export const LB_WL_SERVICE = 'No. servicio'
export const LB_WL_CONFIRMED = 'Confirmados'
export const LB_WL_PROCESSING = 'Procesando'
export const LB_WL_REJECTED = 'Rechazados'
export const LB_WL_DETAILS = 'Detalle'
export const LB_WL_VIEW_MORE = 'Ver mas'
export const LB_WL_VIEW_MINUS = 'Ver menos'
export const LB_WL_ADD_REQUEST = 'Agregar Solicitud'
export const LB_CONFIRMED = 'Confirmado'
export const LB_PROCESS = 'Procesar'
export const LB_PROCESSING = 'Procesando'
export const LB_REJECT = 'Rechazar'
export const LB_REJECTED = 'Rechazado'
export const LB_ADULTS = 'Adultos'
export const LB_YOUNGER = 'Menor'
export const LB_CHILDREN = 'Niños'
export const LB_INFANTS = 'Infantes'
export const LB_CARGO_HAB = 'Cargo hab'
export const LB_VEGETARIAN = 'Vegetariano'
export const LB_GLUTEN_FREE = 'Gluten free'
export const LB_ALLERGIC = 'Alérgico'
export const LB_WL_ACTIVITY = 'Actividades'
export const LB_VEGAN = 'Vegano'
export const LB_REST_ALIM = 'Restricción. alim.'
export const LB_DURATION = 'Duración'
export const LB_SPECIALS = 'Especiales'
export const LB_NEW_SOLICITUD = 'Nueva solicitud'
export const LB_ROOM_CHARGE = 'Cargo habitación'
export const LB_WHAT_ALLERGIES = 'Indica a qué es alérgico'
export const LB_SPECIALITY = 'Especialidad'
export const LB_IN_THIS_WEEK = 'En esta semana'
export const LB_HAVE_CONFIRMATION_NUMBER = '¿Tienes número de confirmación?'
export const LB_CONTINUE_WITH_OUT_CONFIRMATION_NUMBER = 'Continuar sin número de confirmación'
export const LB_REMINDER = 'Recordatorio'

export const LB_START_DATE = 'Fecha de Inicio'
export const LB_END_DATE = 'Fecha de Fin'
export const LB_YES_SEND_ALERT = 'Si, enviar'
export const YOU_SHURE_SEND_ALERT = 'Quieres enviar la notificación'
export const NOTIFICATION_SENT = 'Notificación enviada'
export const NOTIFICATION = 'Notificación'
export const DELETE_NOTIFICATION = 'Eliminar Notificación'
export const LB_NOTIFICATION_ADDED = 'Notificación Agregada'
export const LB_NOTIFICATION_DELETED = 'Notificación Eliminada'

export const HAS_RECURRING_SCHEDULE = '¿Tiene Horario Recurrente?'
export const RECURRING_SCHEDULE_LABEL = 'La trasportación saldrá cada:'
export const LB_MINUTES = 'Minutos'
export const WHAT_WEEK_DAY = '¿Qué día de la semana?'
export const SELECT_SCHEDULE = 'Selecciona los Horarios'
export const LB_ALL = 'Todos'
export const LB_SYNC_GALLERY = 'Sincronizar Galería'
export const LB_SYNC_ALL_GALLERY = 'Sincronizar Toda la Galería'
export const SUCCESSFUL_SYNC = "Sincronización exitosa"
export const ARE_YOU_SHURE_SYNC_IMGS = "Quieres sincronizar la galería";
export const CONFIRM_SYNC_GALLERY = "Sincronizar Ahora";
export const LB_CREATE_LABEL = "Crea tu etiqueta"
export const LB_MARK_TO_HOUR = "Marcar para hora"
export const LB_MARK_TO_MINUTES = "Marcar para minutos"
export const LB_ASSIGN_HOURS = "Asigna los horarios"
export const LB_LABEL_RESULT = "Etiqueta Resultante"
export const LB_NATIONALITY = "Nacionalidad"
export const LB_EVENT = "Evento"
export const LB_ORIGIN = "Origen"
export const LB_DESTINY = "Destino"
export const LB_SALESFORCE_ID = "Salesforce ID"
export const LB_SELECT_SERVICE = "Selecciona un servicio"
export const LB_ANFITRION = "Anfitrión"
export const LB_FLOORS = "Pisos"
export const LB_TOTAL_SUITS = "Número de suites"
export const LB_IMAGE_DIVIDER = "Imagen de división"
export const LB_UDN_ORDER = "Orden de la UDN";
export const LB_EVENT_ORDER = "Orden del evento";
export const LB_IS_THUMB = "¿Es Thumb?"
export const LB_THUMB = "Thumb"
export const LB_IS_GALLERY = "¿Es Galería?"
export const LB_GALLERY = "Galería"
export const LB_IS_LANG = "¿Es multi idioma?"
export const LB_LANG = "Idiomas"
export const LB_SAME_IMG_LANGS = "Misma img en langs"
export const LB_ASPECT_RATIO = "Aspect ratio"
export const LB_ORDER_CONFIG = "Orden"
export const LB_ALLOWED_FORMATS = "Formatos permitidos"
export const LB_LABEL = "Etiqueta"
export const LB_PATH = "Path"
export const LB_MAX_WEIGHT = "Max Weight"
export const LB_MIN_MAX_WIDTH = "Min Max Width"
export const LB_MIN_MAX_HEIGHT = "Min Max Height"
export const LB_IS_TRANSLATABLE = "¿Es traducible?";
export const LB_UPDATE_METRICS = "Actualizar Métricas";
export const LB_LOADING = "Cargando...";
export const LB_CALCULATING_METRICS = "Calculado Métricas...";
export const LB_URL_VIDEO = "URL del video"
export const LB_OPENING_TIME = "Hora de apertura";
export const LB_CLOSING_TIME = "Hora de cierre";
export const LB_LOGO = "Logo";
export const LB_IS_PARK = "¿Es Parque?";
export const LB_NEED_RESERVATION = "¿Necesita Reservación?";
export const LB_SIVEX_CODE = "Código sivex";
export const LB_PHOTO_CODE = "Código de foto";
export const LB_IMG = "Imagen";
export const LB_AFI = "Afi";
export const LB_ICON = "Icono";
export const LB_CATEGORY = "Categoría";
export const LB_DESCRIPTION = "Descripción";
export const LB_BACKGROUND = "Background";
export const LB_IS_MAIN = "¿Es principal?";
export const LB_IS_ACTIVE = "¿Está Activo?";
export const LB_PROJECT = "Proyecto";
